import React from 'react';

const labels = {
  pending: 'Nicht begonnen',
  in_progress: 'In Bearbeitung',
  passed: 'Bestanden',
  failed: 'Nicht bestanden',
  ended: 'Beendet',
  ending: 'Endet',
  active: 'Aktiv',
};

const classMap = {
  ended: 'failed',
  ending: 'pending',
  active: 'passed',
};

export default function StatusBadge({ status, label }) {
  return (
    <span className={`badge badge-${classMap[status] || status}`}>
      {label || labels[status] || status}
    </span>
  );
}
